import React, { useCallback, useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, TextInput, inputm } from 'react-native';

import { useIsFocused } from '@react-navigation/native';

import api from '../services/api';
import moment from 'moment';
import formatCurrency from '../utils/formatCurrency';

const Pages = ({ route, navigation }) => {
  const isFocused = useIsFocused();

  const [isLoading, setIsLoading] = useState(true);
  const [nome, setNome] = useState('');
  const [cidade, setCidade] = useState('');
  const [dataAbertura, setDataAbertura] = useState('');
  const [dataSorteio, setDataSorteio] = useState('');
  const [quantidade, setQuantidade] = useState('');
  const [vendedores, setVendedores] = useState([]);
  const [valor, setValor] = useState(0);
  const [qtdVendido, setQtdVendido] = useState(0);

  const handleObterVendedores = useCallback(
    async (id) => {
      const { data } = await api.get(`sorteios/${id}/relatorio`);
      setVendedores(data);

      const totalVendido = data.reduce((total, vendedor) => {
        return total + (vendedor.quantidade_cartelas_vendidas || 0) * valor;
      }, 0);
      setQtdVendido(totalVendido);

      setIsLoading(false);
    },
    [valor]
  );

  useEffect(() => {
    setIsLoading(true);

    const sorteio = route.params.sorteio;
    setNome(sorteio.nome || 'N/A');
    setCidade(sorteio.cidade?.nome || 'N/A');
    setDataAbertura(sorteio.created_at || sorteio.dataAbertura || new Date());
    const data_sorteio = new Date(
      sorteio.data_realizar_sorteio || sorteio.dataSorteio || new Date()
    );
    data_sorteio.setDate(data_sorteio.getDate() + 1);
    setDataSorteio(data_sorteio);
    setQuantidade(sorteio.quantidade_chance || sorteio.quantidade || 0);
    setValor(sorteio.valor_cartela || 0);
    // Não calcular aqui, será calculado quando os vendedores forem carregados

    if (route.params.vendedores) {
      setVendedores(route.params.vendedores);

      // Calcular total vendido baseado nos dados dos vendedores
      const totalVendido = route.params.vendedores.reduce((total, vendedor) => {
        return (
          total +
          (vendedor.quantidade_cartelas_vendidas || 0) *
            (sorteio.valor_cartela || 0)
        );
      }, 0);
      setQtdVendido(totalVendido);

      setIsLoading(false);
    } else {
      handleObterVendedores(sorteio.id || sorteio._id);
    }
  }, [isFocused, navigation]);

  return (
    <View style={{ flex: 1 }}>
      <View style={{ margin: 20, flex: 1 }}>
        <View
          style={{
            backgroundColor: '#fff',
            padding: 10,
            marginTop: 10,
            borderRadius: 5,
          }}
        >
          <View style={{ flexDirection: 'row' }}>
            <Text style={{ flex: 1, fontWeight: 'bold' }}>{nome}</Text>
            <Text style={{}}>{cidade}</Text>
          </View>

          <View style={{ flexDirection: 'row', marginTop: 10 }}>
            <View style={{ flex: 1, flexDirection: 'row' }}>
              <Text style={{ fontWeight: 'bold' }}>Cadastro</Text>
              <Text>: {moment(dataAbertura).format('DD/MM/YYYY')}</Text>
            </View>

            <View style={{ flex: 1, flexDirection: 'row' }}>
              <Text style={{ fontWeight: 'bold' }}>Sorteio</Text>
              <Text>: {moment(dataSorteio).format('DD/MM/YYYY')}</Text>
            </View>
          </View>

          <View style={{ flexDirection: 'row', marginTop: 10 }}>
            <View style={{ flex: 1, flexDirection: 'row' }}>
              <Text style={{ fontWeight: 'bold' }}>Modelo</Text>
              <Text>: {quantidade} Chances</Text>
            </View>

            <View style={{ flex: 1, flexDirection: 'row' }}>
              <Text style={{ fontWeight: 'bold' }}>Vendedores</Text>
              <Text>: {Array.isArray(vendedores) ? vendedores.length : 0}</Text>
            </View>
          </View>

          <View style={{ flexDirection: 'row', marginTop: 10 }}>
            <View style={{ flex: 1, flexDirection: 'row' }}>
              <Text style={{ fontWeight: 'bold' }}>Valor cartela</Text>
              <Text>: R$ {formatCurrency(valor)}</Text>
            </View>

            <View style={{ flex: 1, flexDirection: 'row' }}>
              <Text style={{ fontWeight: 'bold' }}>Total vendido</Text>
              <Text>: R$ {formatCurrency(qtdVendido)}</Text>
            </View>
          </View>
        </View>

        <View
          style={{
            backgroundColor: '#fff',
            padding: 10,
            marginTop: 10,
            borderRadius: 5,
          }}
        >
          <View style={{}}>
            {isLoading && (
              <View>
                <Text style={{ textAlign: 'center' }}>Carregando...</Text>
              </View>
            )}

            {Array.isArray(vendedores) && vendedores.length > 0
              ? vendedores.map((e, index) => (
                  <View
                    key={e.id || index}
                    style={{
                      borderBottomWidth: 1,
                      borderBottomColor: '#ecf0f1',
                      paddingBottom: 10,
                      flexDirection: 'row',
                    }}
                  >
                    <View style={{ flex: 1, flexDirection: 'row' }}>
                      <Text style={{ flex: 1, fontSize: 12 }}>
                        {e.nome || 'N/A'}
                      </Text>
                    </View>

                    <View style={{ flex: 1, flexDirection: 'row' }}>
                      <Text
                        style={{
                          flex: 1,
                          fontSize: 12,
                          fontWeight: 'bold',
                          marginRight: 5,
                        }}
                      >
                        Cartelas
                      </Text>
                      <Text style={{ flex: 1, fontSize: 12 }}>
                        {e.quantidade_cartelas || 0}
                      </Text>
                    </View>

                    <View style={{ flex: 1, flexDirection: 'row' }}>
                      <Text
                        style={{
                          flex: 1,
                          fontSize: 12,
                          fontWeight: 'bold',
                          marginRight: 5,
                        }}
                      >
                        Vendidos
                      </Text>
                      <Text style={{ flex: 1, fontSize: 12 }}>
                        {e.quantidade_cartelas_vendidas || 0}
                      </Text>
                    </View>

                    <View style={{ flex: 1, flexDirection: 'row-reverse' }}>
                      <Text style={{ fontSize: 12 }}>
                        R${' '}
                        {formatCurrency(
                          (e.quantidade_cartelas_vendidas || 0) * valor
                        )}
                      </Text>
                    </View>
                  </View>
                ))
              : !isLoading &&
                (!Array.isArray(vendedores) || vendedores.length === 0) && (
                  <View>
                    <Text style={{ textAlign: 'center' }}>
                      Nenhum vendedor vinculado
                    </Text>
                  </View>
                )}
          </View>
        </View>
      </View>
    </View>
  );
};

export default Pages;
